export const slugify = (value) =>
  String(value ?? '')
    .toLowerCase()
    .replace(/[^\w ]/g, ' ')
    .trim()
    .replace(/\s+/g, '-');
